<template>
    <div class="performance">
        <div class="performance__main">
            <div class="performance__date-time">
                <span class="performance__date">{{ formattedDate }}</span>
                <span class="performance__day-time">{{ formattedDayTime }}</span>
            </div>
            <a
                class="performance__book-button btn btn--small"
                v-if="props.performance.bookButton?.link && bookable"
                :href="props.performance.bookButton.link"
            >{{ props.performance.bookButton.title }}</a>
            <span
                class="btn btn--small performance__book-button performance__book-button--not-bookable"
                v-else-if="props.performance.isSoldOut"
            >Sold Out</span>
            <span
                class="btn btn--small performance__book-button performance__book-button--not-bookable"
                v-else-if="!bookable"
            >Unavailable</span>
        </div>
        <div class="performance__footer">
            <div class="performance__tags" v-if="tags.length">
                <span class="performance__tag" v-for="tag in tags" :key="tag">{{ tag.trim() }}</span>
            </div>
            <Availability v-if="bookable && featureEnabled('performance.availability')" :event="props.performance" />
        </div>
    </div>
</template>

<script setup>
import { format } from 'date-fns';

import Availability from './Availability.vue';
import { computed } from 'vue';
import { isBookable } from '../../services/performance';

const props = defineProps({
    performance: {
        type: Object,
        required: true,
    }
});

const featureEnabled = window.featureEnabled; //Required for access in template

const bookable = computed(() => isBookable(props.performance));

const short_months = ['3','4','5','6','7'];
const formattedDate = computed(() => {
    return short_months.includes(format(props.performance.startDate, 'M')) ?
        format(props.performance.startDate, 'MMMM d') :
        format(props.performance.startDate, 'MMM d');
});

const formattedDayTime = computed(() => {
    const mins = format(props.performance.startDate, 'mm');
    const time = mins === '00'
        ? format(props.performance.startDate, 'haaa')
        : format(props.performance.startDate, 'h:mmaaa');
    return format(props.performance.startDate, 'EEEE, ') + time;
});

const tags = computed(() => props.performance.accessibility ?? []);
</script>
